// Reduced-motion-aware framer-motion variants for the global SearchBar.
//
// The OS "reduce motion" setting must collapse the decorative scale/rotate/
// slide animations to a plain fade (motion-language / a11y law, WCAG 2.3.3).
// Keeping these as pure builders (a11y flag in, variant object out) lets them
// be unit-tested without a DOM and shared by UserItem + WheelItem so the two
// result rows can never drift.

/** Result-row (user + wheel) entry / hover / tap variants. */
export function searchItemVariants(reduceMotion) {
  if (reduceMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      hover: {},
      tap: {},
    };
  }
  return {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    // #965: no lifted-card hover (scale + box-shadow) — the row stays flush,
    // matching the Chat side-pane row's WhatsApp-style density treatment. The
    // hover cue is a plain background tint on SearchItem itself (styles.js).
    hover: {},
    tap: {
      scale: 0.98,
      transition: { duration: 0.1 },
    },
  };
}

/** Magnifier (search) icon variants. */
export function searchIconVariants(reduceMotion) {
  return {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      scale: reduceMotion ? 1 : [0.8, 1.2, 1],
      rotate: reduceMotion ? 0 : [-10, 10, 0],
      transition: { duration: reduceMotion ? 0 : 0.6, ease: "easeInOut" },
    },
    exit: { opacity: 0 },
  };
}

/** Clear (×) icon variants. */
export function searchClearIconVariants(reduceMotion) {
  return {
    hidden: { opacity: 0, scale: reduceMotion ? 1 : 0.8 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: reduceMotion ? 1 : 0.7 },
    hover: reduceMotion ? {} : { scale: 1.3 },
    tap: reduceMotion ? {} : { scale: 0.9 },
  };
}
